import React, { Component } from 'react';
import {
    Redirect,
    Route,
    Switch,
    withRouter
} from 'react-router-dom';

import { connect } from 'react-redux';

import NoResults from '@/noResults/NoResults';
import Routes from './routes';

import { getState } from './store';
import { actions as authActions } from '@/auth/sagaSlice';

class App extends Component {

    routeRender = (route, props) => {

        if (route.auth && !getState().auth.isSignedIn) {

            return <Redirect to={{
                pathname: '/login',
                state: {
                    from: props.location
                }
            }} />;
        }

        if (!route.layout) {

            route.component = withRouter(route.component);

            return <route.component {...props} />;
        }

        route.layout = withRouter(route.layout);

        global.document.title = route.title || route.path;

        return (
            <route.layout {...props}>
                <route.component {...props} />
            </route.layout>
        );
    }

    mappedRoute = (route, key) => (
        <Route
            key={key}
            path={route.path}
            exact={route.exact}
            render={props => this.routeRender(route, props)}
        />
    )

    render() {

        const {
            isSignedIn,
            isCheckingSessions,
            assertSession
        } = this.props;

        // Create a loop to check sessions every minute
        if (isSignedIn && !isCheckingSessions) {

            assertSession();
        };

        return (
            <Switch>
                { Routes.map(this.mappedRoute) }
                <Route render={ NoResults } />
            </Switch>
        );

    }

};

export default connect(state => ({
    isSignedIn: state.auth.isSignedIn,
    isCheckingSessions: state.auth.isCheckingSessions
}), authActions)(App);
